/**
 * Storefront runtime (hybrid.js) listens for POPUP_CLOSE to advance multi-popup
 * add-to-cart chains. Cart drawer is not auto-opened after the chain.
 */
const recentCloseByPopupId = new Map();
const CLOSE_NOTIFY_DEDUPE_MS = 400;

export function notifyPopupClosedRuntime(popupData, reason = "user_close") {
  if (!popupData || typeof window === "undefined") return;
  try {
    if (window.__WEUPSELL_PREVIEW_PROPS__?.is_preview_mode === true) return;
  } catch (_) {
    /* ignore */
  }

  const popupId = popupData?._id;
  if (popupId) {
    const now = Date.now();
    const lastNotifiedAt = recentCloseByPopupId.get(popupId) || 0;
    if (now - lastNotifiedAt < CLOSE_NOTIFY_DEDUPE_MS) return;
    recentCloseByPopupId.set(popupId, now);
  }

  window.postMessage(
    {
      type: "POPUP_CLOSE",
      props: { popupValue: popupData, reason },
    },
    "*"
  );
}
